module.exports = "/_next/static/images/2e4ef7d33318031b8670793c39062762-blog-xs-1x.jpg.webp";